import { preview } from '@/components/form/preview'

import { useTexts } from './hooks/useTexts'
import { BulkViewData } from '../../hooks/useBulkViewData/types'

type Props = {
  bulkData: BulkViewData
}

export function ServiceTime(props: Props) {
  const {
    bulkData: { serviceTime },
  } = props

  const texts = useTexts()

  return (
    <preview.Field label={texts.serviceTime.label}>
      {serviceTime === 'mixed' ? (
        <preview.MixValue />
      ) : (
        <preview.DurationValue format="DURATION_HH_MM">{serviceTime}</preview.DurationValue>
      )}
    </preview.Field>
  )
}
